module.exports = require("webpack-node-externals");


//////////////////
// WEBPACK FOOTER
// external "webpack-node-externals"
// module id = 11
// module chunks = 0